export default __webpack_public_path__ + "static/media/rank2.3ca0ef67.svg";